import { set } from 'lodash';

const context = {
  state: {
    loading: false,
    redirectTo: null,
    snackbar: { show: false, button: { show: true, text: 'Fechar' } },
    protocolo: sessionStorage.getItem('protocolo') || null,
    protocoloLocked: sessionStorage.getItem('protocolo') != null,
  },
  mutations: {
    SET_LOADING_DIALOG: (state, loading) => {
      set(state, 'loading', loading);
    },
    SET_REDIRECT_TO: (state, redirectTo) => {
      set(state, 'redirectTo', redirectTo);
    },
    TOGGLE_SNACKBAR: (state, payload) => {
      state.snackbar = { ...state.snackbar, ...payload };
    },
    SET_PROTOCOLO: (state, protocolo) => {
      if (protocolo) {
        sessionStorage.setItem('protocolo', protocolo);
      } else {
        sessionStorage.removeItem('protocolo');
      }
      state.protocolo = protocolo;
      state.protocoloLocked = protocolo != null;
    },
  },
  actions: {
    async setLoadingDialog({ commit }, loading) {
      commit('SET_LOADING_DIALOG', loading);
    },
    async setRedirectTo({ commit }, redirectTo) {
      commit('SET_REDIRECT_TO', redirectTo);
    },
    toggleSnackbar({ commit }, payload) {
      commit('TOGGLE_SNACKBAR', payload);
    },
    initProtocolo({ commit, state }, protocolo) {
      if (!state.protocoloLocked || state.protocolo === protocolo) {
        commit('SET_PROTOCOLO', protocolo);
      }
    },
    setProtocolo({ commit }, protocolo) {
      commit('SET_PROTOCOLO', protocolo);
    },
    clearProtocolo({ commit }) {
      commit('SET_PROTOCOLO', null);
    },
  },
};
export default context;
